import type { Client, RequestContext } from "../client";
import type { PaginatedCollection, IIdName } from "../resources/index";
import type { PlatformHubAccountResource } from "../resources/platformHubAccountResource";
export class PlatformHubAccountRepository {
    private client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    create(account: CreatePlatformHubAccountCommand) {
        return this.client.post<CreatePlatformHubAccountResponse>(this.requestContext, "~/api/platformhub/accounts", account);
    }
    async get(args?: GetPlatformHubAccountsRequest) {
        const response = await this.client.get<GetPlatformHubAccountsResponse>(this.requestContext, "~/api/platformhub/accounts{?skip,take,name}", args);
        return response.Accounts;
    }
    async getById(accountId: string) {
        const response = await this.client.get<GetPlatformHubAccountByIdResponse>(this.requestContext, "~/api/platformhub/accounts/{id}", { id: accountId });
        return response.Account;
    }
    async modify(account: ModifyPlatformHubAccountCommand) {
        await this.client.put<ModifyPlatformHubAccountResponse>(this.requestContext, "~/api/platformhub/accounts/{id}", account, { id: account.Id });
    }
    delete(accountId: string) {
        return this.client.del(this.requestContext, "~/api/platformhub/accounts/{id}", null, { id: accountId });
    }
    async getAccountNames(ids: string[]) {
        const response = await this.client.get<GetPlatformHubAccountNamesBffResponse>(this.requestContext, "~/bff/spaces/{spaceId}/platformhub/accounts/names{?ids}", { ids });
        return response.Accounts;
    }
}
export type CreatePlatformHubAccountCommand = PlatformHubAccountResource;
export interface CreatePlatformHubAccountResponse {
    Id: string;
}
export type GetPlatformHubAccountsRequest = {
    Skip?: number;
    Take?: number;
    Name?: string;
};
export interface GetPlatformHubAccountsResponse {
    Accounts: PaginatedCollection<PlatformHubAccountResource>;
}
export interface GetPlatformHubAccountByIdResponse {
    Account: PlatformHubAccountResource;
}
export type ModifyPlatformHubAccountCommand = PlatformHubAccountResource;
export interface ModifyPlatformHubAccountResponse {
}
// API Request/Response interfaces for Names
export interface GetPlatformHubAccountNamesBffResponse {
    Accounts: GetPlatformHubAccountNamesBffResponseIdAndName[];
}
export interface GetPlatformHubAccountNamesBffResponseIdAndName extends IIdName {
}
